import React, { createContext, useContext, useState } from 'react';
import { supabase } from '../supabaseClient';

const MediaContext = createContext();

export const MediaProvider = ({ children, userId }) => {
  const [uploading, setUploading] = useState(false);

  const uploadFile = async (file, bucket = 'Storage') => {
    if (!file || !userId) return null;
    setUploading(true);
    try {
      const fileType = file.type.startsWith('image/') ? 'images' : 'documents';
      const fileName = `${Date.now()}_${file.name}`;
      const filePath = `${userId}/${fileType}/${fileName}`;

      const { error: uploadError } = await supabase
        .storage
        .from(bucket)
        .upload(filePath, file);

      if (uploadError) throw uploadError;

      const { data: { publicUrl } } = supabase
        .storage
        .from(bucket)
        .getPublicUrl(filePath);

      return publicUrl;
    } catch (error) {
      console.error('Upload error:', error);
      return null;
    } finally {
      setUploading(false);
    }
  };

  return (
    <MediaContext.Provider value={{ uploadFile, uploading }}>
      {children}
    </MediaContext.Provider>
  );
};

export const useMedia = () => useContext(MediaContext);
